
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { ReporterService, MediaService } from '@/services/index'
import { IMG_HOST } from '@/config/env'
import UploadImg from '@/components/upload_img/index.vue'
import AddExp from './components/addExp.vue'
import { IExpData } from '@/types/reporter-types'
import { parseTime } from '@/filters'

@Component({
    components: {
        UploadImg,
        AddExp
    }
})
export default class extends Vue {
    private validateMedia = (rule: any, value: object, callback: Function) => {
        if (Object.keys(value).length === 0) {
            callback(new Error('请输入供职媒体'))
        } else {
            callback()
        }
    }
    private typeOptions = [
        { value: 0, label: '记者' },
        { value: 1, label: '特邀记者' },
        { value: 2, label: '通讯员' },
        { value: 3, label: '投稿作者' },
        { value: 4, label: '实习生' }
    ]
    private reporterRules = {
        name: [
            { required: true, message: '请输入记者名称', trigger: 'blur' },
            { min: 2, max: 8, message: '请输入正确的名称，2-8个字符', trigger: 'blur' }
        ],
        media: [
            { required: true, message: '请输入供职媒体', trigger: 'blur' },
            { validator: this.validateMedia, trigger: 'blur' }
        ],
        intro: [
            { 
                min: 0, max: 1000, 
                message: '请输入正确的记者介绍，0-1000个字符', 
                trigger: 'blur'
            }
        ]
    }
    private IMG_HOST = IMG_HOST
    private reporterForm: any = {
        name: '',
        media: {},
        gender: '1',
        avatar: '',
        intro: '',
        work_exps: [],
        type: 0
    }
    private mediasOptions = []
    private loading: boolean = false

    private uploadCallback(url: string) {
        const $reporterForm = this.$refs.reporterForm as ElForm
        this.reporterForm.avatar = url
        $reporterForm.validateField('avatar')
    }

    private async querySuggestions(query: string) {
        const result = await MediaService.searchMedia({ value: query })
        if (result.status === 200) {
            const medias = result.data.map((item: any) => {
                return { value: item.id, label: item.name }
            })
            this.mediasOptions = medias
        }
    }

    private onCreateCareer() {
        (this.$refs.addExp as any).show(null, (
            exp: IExpData
        ) => {
            this.reporterForm.work_exps.push(exp)
        })
    }

    private onRemoveExp(expIndex: number) {
        this.$confirm('确定删除该工作经历?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.reporterForm.work_exps.splice(expIndex, 1)
        }).catch(() => {})
    }

    private onEditExp(expIndex: number) {
        (this.$refs.addExp as any).show(this.reporterForm.work_exps[expIndex], (
            exp: IExpData
        ) => {
            this.reporterForm.work_exps.splice(expIndex, 1, exp)
        })
    }

    private parseTime(time: any, format: string) {
        if (typeof time === 'string' && !time.length) {
            return '至今'
        }
        return parseTime(time, format)
    }

    private onCreate() {
        (this.$refs.reporterForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const { name, gender, avatar, intro, media, work_exps, type } = this.reporterForm
                const params = { 
                    name: name, 
                    gender: Number(gender),
                    avatar: avatar,
                    intro: intro,
                    media: {
                        id: media.value,
                        name: media.label
                    },
                    work_exps: work_exps,
                    type
                }
                const result = await ReporterService.create(params)
                if (result.status === 200) {
                    (this.$refs.reporterForm as ElForm).resetFields()
                    this.reporterForm.work_exps = []
                    this.$message({ type: 'success', message: '操作成功' })
                } else if (result.status === 400) {
                    this.$message({ type: 'error', message: '该记者已存在' })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            }
        })
    }

    private onCancel() {
        this.$router.go(-1)
    }
}
